import React from 'react';

import { I18n } from 'aws-amplify';

import { Task } from '../../../utils/task';
import { FormUtils } from '../../../utils/form';

import TextField from '../../form/text-field';
import TextAreaField from '../../form/textarea-field';
import SelectSearchField from '../../form/select-search-field';
import CheckboxMultiField from '../../form/checkbox-multi-field';
import RadioMultiField from '../../form/radio-multi-field';
import SelectField from '../../form/select-field';

import constants from '../../../constants';


import { scrollToTop } from '../../../utils/ui';

class DetailsForm extends React.Component {
    constructor(props) {

        super(props);

        const { bPitch = {}, client = {}, project = {} } = props;

        const { projectName: pitchName, brandName } = project;

        this.state = {
            fields: {
                pitchName: {
                    onChange: this.onChangeForm.bind(this, 'pitchName'),
                    // onBlur: this.onSave.bind(this),
                    successIcon: false,
                    markAsRequired: true
                },
                brandName: {
                    onChange: this.onChangeForm.bind(this, 'brandName'),
                    // onBlur: this.onSave.bind(this),
                    successIcon: false,
                    markAsRequired: true
                },
                product: {
                    onChange: this.onChangeForm.bind(this, 'product'),
                    // onBlur: this.onSave.bind(this),
                    successIcon: false,
                    markAsRequired: true
                },
                description: {
                    onChange: this.onChangeForm.bind(this, 'description'),
                    // onBlur: this.onSave.bind(this),
                    successIcon: false,
                    markAsRequired: true
                },
                pitchSegment: {
                    onChange: this.onChangeFormValue.bind(this, 'pitchSegment'),
                    // onBlur: this.onSave.bind(this),
                    successIcon: false,
                    markAsRequired: true
                },
            },
            errors: {},
            form: { ...bPitch, pitchName, brandName },
            task: {},
            submit_task: {}
        }
    }

    componentDidMount() {
        scrollToTop();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {

        const task = this.props.task || {};
        const prev = prevProps && prevProps.task || {};

        //console.dir({ task: task, prev: prev });

        if (task != prev) {

            var nextState = Object.assign({}, prevState, { task: task });

            const { bPitch = {} } = this.props;

            Object.keys(this.state.fields).forEach((item) => {

                if (bPitch[item]) {
                    nextState.form[item] = bPitch[item];
                }

            });

            this.setState(nextState);
        }
    }

    onChangeForm(prop, e) {

        const value = e.target.value;

        this.setState((prevState) => {

            var nextState = Object.assign({}, prevState);

            nextState.form[prop] = value;
            nextState.errors[prop] = null;

            return nextState;

        }, () => this.onSaving());
    }

    onChangeFormValue(prop, value) {

        this.setState((prevState) => {

            var nextState = Object.assign({}, prevState);

            nextState.form[prop] = value;
            nextState.errors[prop] = null;

            return nextState;

        }, () => this.onSaving());
    }

    getData() {

        var data = {
            projectId: this.props.match.params.projectId,
            ...this.props.bPitch,
            ...this.state.form
        };

        return data;
    }

    onSaving() {

        clearTimeout(this.t);
        this.t = setTimeout(() => this.onSave(), 1000)
    }

    onSave() {

        var submit_task = new Task();

        submit_task.start();

        this.setState({ submit_task: submit_task });

        this.props.update_bpitch(this.getData())
            .then(({ task, errors }) => {

                this.setState({ submit_task: task, errors: errors });
            });
    }

    render() {

        return (
            <div>

                <h1 className="title-bpool medium">{I18n.get("Detalhes do Pitch")}</h1>

                <div className="bp-event-section" style={{ marginTop: '3rem', maxWidth: '40rem' }}>

                    <TextField
                        {...this.state.fields.pitchName}
                        label={I18n.get("De um nome para seu Pitch")}
                        value={this.state.form.pitchName}
                        error={this.state.errors.pitchName} />

                    <br />

                    <TextField
                        {...this.state.fields.brandName}
                        label={I18n.get("Marca")}
                        value={this.state.form.brandName}
                        error={this.state.errors.brandName} />

                    <br />

                    <TextField
                        {...this.state.fields.product}
                        label={I18n.get("Produto / Serviço")}
                        value={this.state.form.product}
                        error={this.state.errors.product} />

                    <br />

                    <TextAreaField
                        {...this.state.fields.description}
                        label={I18n.get("Breve descrição do seu pitch")} 
                        placeholder={I18n.get("Encontrar o parceiro ideal para…")}
                        value={this.state.form.description}
                        error={this.state.errors.description} />

                    <br />

                    <SelectSearchField
                        {...this.state.fields.pitchSegment}
                        label={I18n.get("Segmento2")} 
                        values={this.props.bp.sectorsFlat}
                        value={this.state.form.pitchSegment}
                        error={this.state.errors.pitchSegment} />

                </div>
            </div>
        );
    }
}

export default DetailsForm;
